var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_537)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#B72A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.39 0.000170827L1920 0.00012207L1920 342L1175 1082L-6.00024 1082L1081.39 0.000170827Z",
    fill: "url(#paint0_linear_472_537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1080L1171 1080L1920 335L1920 1080Z",
    fill: "url(#paint1_linear_472_537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.644 539.644L-0.229429 1079.52L8.73394e-05 8.73394e-05L539.644 539.644Z",
    fill: "url(#paint2_linear_472_537)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_537",
    x1: 957,
    y1: 1082,
    x2: 1992,
    y2: 57.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6C6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_537",
    x1: 904,
    y1: 83.186,
    x2: 1718,
    y2: 959.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72A25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_472_537",
    x1: 202,
    y1: 727.186,
    x2: -330,
    y2: 203.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6C6D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWeb);
export default __webpack_public_path__ + "static/media/background-web.288890fc38c70ac2cd2ab07cdf0d2acd.svg";
export { ForwardRef as ReactComponent };